import { render, staticRenderFns } from "./addSlideBanner.vue?vue&type=template&id=6b049e80&lang=pug"
import script from "./addSlideBanner.vue?vue&type=script&lang=js"
export * from "./addSlideBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports